/* ==========================================================================
   Visotale — mizahi çerez bandı: mantık
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'visotale_cookie_consent'; // 'accepted' | 'necessary_only'
  var banner = document.querySelector('[data-cookie-banner]');
  if (!banner) return;

  function getStored() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }
  function setStored(value) {
    try { localStorage.setItem(STORAGE_KEY, value); } catch (e) { /* sessiz geç */ }
  }

  function applyShopifyConsent(accepted) {
    // Shopify'nin Customer Privacy API'si varsa, tercih ona da bildirilir
    // ki reklam/analitik script'leri gerçekten bu karara uysun.
    if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(
          { analytics: accepted, marketing: accepted, preferences: accepted },
          function () {}
        );
      } catch (e) { /* API henüz hazır değilse sessiz geç */ }
    }
  }

  function hideBanner() {
    banner.classList.add('is-leaving');
    setTimeout(function () { banner.hidden = true; }, 350);
  }

  function decide(value) {
    setStored(value);
    applyShopifyConsent(value === 'accepted');
    hideBanner();
  }

  document.querySelectorAll('[data-cookie-accept]').forEach(function (b) {
    b.addEventListener('click', function () { decide('accepted'); });
  });
  document.querySelectorAll('[data-cookie-necessary]').forEach(function (b) {
    b.addEventListener('click', function () { decide('necessary_only'); });
  });

  // daha önce bir karar verilmemişse bandı göster
  if (!getStored()) {
    // sayfa yüklenir yüklenmez değil, küçük bir gecikmeyle göstermek
    // daha az saldırgan hissettiriyor
    setTimeout(function () { banner.hidden = false; }, 600);
  } else {
    applyShopifyConsent(getStored() === 'accepted');
  }
})();
